module.exports = __webpack_public_path__ + "static/media/bg-bottom.3fdbc465.png";